import { ChainType } from '@polaris/core/models'
import { featureFlagsAtom } from '@polaris/core/stores'
import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import type { EcosystemWalletOptions } from '@/src/hooks/wallet/use-wallet-options'
import { mpcWalletAddressesWithNamadaOverrideAtom } from '@/src/stores/mpc/atoms'

export const useVaultWalletOptions = () => {
  const featureFlags = useAtomValue(featureFlagsAtom)
  const mpcWalletAddresses = useAtomValue(
    mpcWalletAddressesWithNamadaOverrideAtom,
  )

  return useMemo<EcosystemWalletOptions>(
    () => ({
      chainType: ChainType.Namada,
      ecosystemName: 'Vault',
      ecosystemImgUrl: '/assets/wallets/cosmos.svg',
      connectableOptions: [],
      connectedWalletOption: {
        id: 'vault',
        displayName: 'Vault',
        logoUrl: '',
        accountName: 'Vault Test',
        disconnect: () => {},
      },
      installableWalletOptions: [],
      enabled: featureFlags.privacy,
      ready: mpcWalletAddresses !== undefined,
    }),
    [featureFlags.privacy, mpcWalletAddresses],
  )
}
